import { Blockquote, Inset, Text } from "@radix-ui/themes";


export default function Y2024M04D08() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>

          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2024-04-08.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                &copy;Progetto Archetypon
              </Text>
            </Inset>
          </div>

          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                  8 April 2024, University of Padua (Italy)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                  Lecture: <i>Labirinto e Alteritá</i>, by Adrián Navigante
                  </Blockquote>
                  <Blockquote size="2" color>
                  Lecture at the University of Padua
                  </Blockquote>
                  <Blockquote size="2" color>
                    Center Interstices in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    Adrián Navigante was invited to speak, within the framework of the interdisciplinary project <i>Archetypon</i>, about the meaning of the Labyrinth and its connection with the notion of alterity, its anthropological, philosophical and historical implications.
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
